import { homeBannerEditComponent } from './home-banner-edit.component';

export const homeBannerEdit = angular
	.module('components.homeBanner.homeBannerEdit', [])
	.component('homeBannerEdit', homeBannerEditComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/components/home-banner/home-banner-edit/home-banner-edit.module.js